import ContactFormPro from "@/components/feature/ContactFormPro";
import GoogleReviews from "@/components/feature/GoogleReviews";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import PiecesSection from "@/components/feature/PiecesSection";
import ServicesSection from "@/components/feature/ServicesSection";
import { getVillePieces, getVilleServices } from "@/mocks/servicesSections";
import VideoDiagnostic from "@/components/feature/VideoDiagnostic";
import { useSEO } from "@/hooks/useSEO";
import { seoData } from "@/data/seoData";
import Hero from "./components/Hero";
import LocalIntro from "./components/LocalIntro";
import InterventionsGrid from "./components/InterventionsGrid";
import FAQ from "./components/FAQ";
import Gallery from "./components/Gallery";
import InternalLinks from "./components/InternalLinks";
import FloatingButton from "./components/FloatingButton";

function ContactFormSaverne() {
  return (
    <ContactFormPro
      variant="inline"
      formId="devis-form-saverne"
      ctaTitle="Besoin d'un réparateur de fenêtre à Saverne ?"
      ctaSubtitle="Appel gratuit, devis sans engagement. Intervention possible sous 24-48h."
    />
  );
}

export default function ReparationFenetreSavernePage() {
  useSEO(seoData.reparationFenetreSaverne);
  return (
    <>
      <Header />
      <main>
        <Hero />
        <VideoDiagnostic />
        <PiecesSection {...getVillePieces("Saverne")} />
        <ServicesSection {...getVilleServices("Saverne")} />
        <LocalIntro />
        <InterventionsGrid />
        <FAQ />
        <Gallery />
        <InternalLinks />
        <GoogleReviews />
        <ContactFormSaverne />
      </main>
      <Footer />
      <FloatingButton />
    </>
  );
}